import { render, staticRenderFns } from "./Cookiewall.vue?vue&type=template&id=d3b364c4&"
import script from "./Cookiewall.vue?vue&type=script&lang=js&"
export * from "./Cookiewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports